import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { unicodeToString } from "../../../../Js/Common";

const pathToParentMenu = ["root"];

const WwBigSubHeading = (props) => {
    const [classnames, setClassnames] = useState('');

    useEffect(() => {
        // if(props.data && props.data.class){
        //     setClassnames(props.data.class);
        // }
    },[props.data])

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12}>
            <Typography sx={{ color: "primary.main", fontSize: "30px", textAlign: "center" }}>
              <div
                className={classnames}
                id={props.data.myId.self}
                dangerouslySetInnerHTML={{
                  __html: unicodeToString(props.data.source),
                }}
                style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
              ></div>
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WwBigSubHeading;
